// extracted by mini-css-extract-plugin
module.exports = {"table":"ActivitiesTable_table__2bT0b","columnIndent":"ActivitiesTable_columnIndent__F72NQ","container":"ActivitiesTable_container__1nuOu"};